<template>
  <div class="basic-block block-lead-free" :style="styles">
    <img
      src="/static/img/recommend/lp/houen/lead_free.png"
      alt=""
      class="block-lead-free__lead"
    />
    <lp-base-button
    class="block-lead-free__btn"
      label="暴露数を占う"
      design="primary"
      :color-scheme="colorScheme"
      @clicked="clicked"
    />
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockLeadFree',
  components: {
    LpBaseButton,
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: Number,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked () {
      const payload = {
        link: `/recommend/lp/${this.lpId}/basic/input`,
        param: {
          'event_category': `LP${this.lpId}-free-shindan-button`,
        }
      }
      window.gtag('event', 'click', payload.param)
      let href = payload.link
      if (href === 'subsc') { href = this.subscUrl }
      if (href) { location.href = this.$handoverParams(href) }
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

.block-lead-free {
  background: #4D89C3;
  padding: 38px 20px 60px;
  &__lead {
    display: block;
    width: 100%;
    max-width: 500px;
    margin: 0 auto 24px;
  }
  &__btn {
    width: 89.552%;
    max-width: 340px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/houen/blocks/BlockLeadFree.vue